import React from "react";

export default function SearchInput({ filter, setFilter = () => {} }) {
  return (
    <input
      type="text"
      placeholder="Search for a device..."
      style={{
        padding: 10,
        width: "100%",
        backgroundColor: "#1b3f62",
        color: "white",
        border: "none",
        borderBottom: "1px solid white",
        fontSize: 20,
        marginBottom: 10,
      }}
      value={filter}
      onChange={(e) => setFilter(e.target.value)}
    />
  );
}
